import { FC } from 'react';

import ReleaseNotes from './components/ReleaseNotes/ReleaseNotes';
import Header from 'components/Header/Header';
import usePushNotifications from 'hooks/common/usePushNotifications';

const ProfilePage: FC = () => {
  usePushNotifications();

  return (
    <div>
      <Header />
      <ReleaseNotes />
    </div>
  );
};

export default ProfilePage;
